import React, { useEffect, useState } from "react";
import { Phone, Menu, X, LogIn } from "lucide-react";
import { Link } from "react-router-dom";
import { company, navLinks } from "../mock";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "py-2" : "py-4"
      }`}
      style={{
        background: scrolled
          ? "rgba(255, 255, 255, 0.92)"
          : "rgba(255, 255, 255, 0.78)",
        backdropFilter: "blur(14px)",
        WebkitBackdropFilter: "blur(14px)",
        borderBottom: scrolled ? "1px solid rgba(7,11,95,0.08)" : "1px solid rgba(255,255,255,0.4)",
        boxShadow: scrolled ? "0 8px 30px -12px rgba(7,11,95,0.18)" : "none"
      }}
    >
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo (transparent PNG on light header) */}
        <a href="#home" className="flex items-center group">
          <img
            src="/assets/tcl-logo.png"
            alt="Top Choice Lending"
            className={`w-auto object-contain transition-all duration-300 ${scrolled ? "h-10 md:h-11" : "h-12 md:h-14"}`}
          />
        </a>

        {/* Nav */}
        <nav className="hidden lg:flex items-center gap-8">
          {navLinks.map((l) => (
            <a key={l.href} href={l.href} className="nav-link-dark">
              {l.label}
            </a>
          ))}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href={`tel:${company.phoneRaw}`}
            className="flex items-center gap-2 text-sm font-semibold hover:opacity-80 transition-opacity"
            style={{ color: "#070B5F" }}
          >
            <Phone size={15} style={{ color: "#6BA82E" }} />
            {company.phone}
          </a>
          <Link to="/portal/login" className="flex items-center gap-1.5 text-sm font-semibold hover:opacity-80 transition-opacity" style={{ color: "#070B5F" }} title="Loan Officer Login">
            <LogIn size={14} /> Portal
          </Link>
          <a href={company.applyUrl} target="_blank" rel="noreferrer" className="btn-gold">
            Apply Now
          </a>
        </div>

        {/* Mobile toggle */}
        <button
          className="lg:hidden p-2"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
          style={{ color: "#070B5F" }}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden mt-3 mx-4 rounded-2xl p-6 shadow-3d" style={{ background: "rgba(255,255,255,0.98)", border: "1px solid rgba(7,11,95,0.08)" }}>
          <div className="flex flex-col gap-4">
            {navLinks.map((l) => (
              <a
                key={l.href}
                href={l.href}
                className="font-medium"
                style={{ color: "#070B5F" }}
                onClick={() => setOpen(false)}
              >
                {l.label}
              </a>
            ))}
            <a
              href={`tel:${company.phoneRaw}`}
              className="flex items-center gap-2 text-sm font-semibold"
              style={{ color: "#070B5F" }}
            >
              <Phone size={14} style={{ color: "#6BA82E" }} /> {company.phone}
            </a>
            <Link to="/portal/login" onClick={() => setOpen(false)} className="flex items-center gap-2 text-sm font-semibold" style={{ color: "#070B5F" }}>
              <LogIn size={14} style={{ color: "#6BA82E" }} /> Portal Login
            </Link>
            <a href={company.applyUrl} target="_blank" rel="noreferrer" className="btn-gold mt-2 justify-center">
              Apply Now
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
